import React from "react";
import styles from "./Button.css";
const classNames = require("classnames");

type visualWeight = "primary" | "secondary";
type shape = "square" | "formButton" | "condensed" | "round";

interface Props {
  href?: string;
  text: string;
  visualWeight: visualWeight;
  shape: shape;
  extraClassName?: string;
  onClick?: () => void;
  openInNewTab?: boolean;
}

export const Button = ({
  href,
  text,
  visualWeight,
  shape,
  extraClassName,
  onClick,
  openInNewTab
}: Props) => {
  const classes = classNames(
    styles.button,
    styles[visualWeight],
    styles[shape],
    extraClassName
  );

  if (href) {
    return (
      <a
        className={classes}
        href={href}
        onClick={onClick}
        {...(openInNewTab ? { target: "_blank" } : {})}
      >
        {text}
      </a>
    );
  }

  return (
    <button className={classes} onClick={onClick}>
      {text}
    </button>
  );
};
